import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

export const FAQSection = ({ items }) => (
  <Accordion type="single" collapsible data-testid="faq-accordion">
    {items.map((item, idx) => (
      <AccordionItem key={item.question} value={`faq-${idx}`} className="border-white/10">
        <AccordionTrigger data-testid={`faq-question-${idx}`} className="text-white text-base font-serif-display hover:no-underline">
          {item.question}
        </AccordionTrigger>
        <AccordionContent data-testid={`faq-answer-${idx}`} className="text-white/60 text-sm leading-relaxed">
          {item.answer}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
